import { useUserStore } from '~/stores/user'

export default defineNuxtRouteMiddleware((_t, _f) => {
  const store = useUserStore()
  const ok =
    store.$state.user &&
    (store.$state.user.Role == 'buyer' ||
      store.$state.user.Site_Admin ||
      store.$state.user.Permissions['fulfillment'])
  if (!ok) {
    return abortNavigation(
      createError({ statusMessage: 'Insufficient Permissions', statusCode: 401, fatal: true }),
    )
  }
})
